/* import ReactDOM from "react-dom"
export function replaceHydrateFunction() {
  return (element, container, callback) => {
    ReactDOM.render(element, container, callback)
  }
} */

import React from "react"
import NavbarProvider from "./src/context/navbar"
import { ToastContainer } from 'react-toastify'

import "./src/styles/global.css"
import { registerFCMToken, onMessageListener } from "./src/utils/firebaseUtils"
import 'react-toastify/dist/ReactToastify.css';

const RootWrapper = ({ element }) => (
  <>
    <ToastContainer />
    {NavbarProvider({ element })}
  </>
)

export const wrapRootElement = RootWrapper

export const onClientEntry = async () => {
  if (typeof window === "undefined") {
    return
  }

  if (process.env.NODE_ENV === "development" && "serviceWorker" in navigator) {
    navigator.serviceWorker
      .getRegistrations()
      .then(registrations =>
        registrations.forEach(registration => {
          // Only unregister Gatsby/Workbox service workers, keep Firebase messaging worker
          if (!registration.scope.includes("firebase-cloud-messaging-push-scope")) {
            registration.unregister()
          }
        })
      )
      .catch(() => {})
  }

  if (process.env.NODE_ENV === "development" && "caches" in window) {
    caches
      .keys()
      .then(keys =>
        Promise.all(
          keys
            .filter(key => key.includes("gatsby") || key.includes("workbox"))
            .map(key => caches.delete(key))
        )
      )
      .catch(() => {})
  }

  // Request FCM token for push notifications
  try {
    const token = await registerFCMToken()
    console.log("FCM token acquired:", token)
    
    // Listen for foreground messages
    onMessageListener()
  } catch (error) {
    console.error("Error getting FCM token:", error)
  }
}

export const onServiceWorkerUpdateReady = () => {
  const answer = window.confirm(
    `This application has been updated. ` +
    `Reload to display the latest version?`
  )

  if (answer === true) {
    window.location.reload()
  }
}
